import React, {
  FC,
  useState,
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import { Box, VStack, Text, HStack, Pressable } from "native-base";
import { MicIcon, VideoIcon } from "../../../assets/icons/icon-assets";
import { Linking } from "react-native";
import { Loc } from "../../../App/Loc";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import Messages from "../../../Screens/chat/screens/MainScreen";
import { setConvo } from "../../../Redux/Actions/convoActions";
import _ from "lodash";
import * as AV from "../../../AVCore/AVCore";
import { Media } from "../../../AVCore/Media";
import useConvoChat from "../../../Hooks/useConvoChat";
import { setEntitydata, setUser } from "../../../Redux/Actions/userActions";
import { useParams, useNavigate } from "react-router-dom";
import AVCancel from "../../../components/common/AVCancel";
import AVInputtext from "../../../components/AVInputtext";
import { AVBase } from "../../../AVCore/AVBase";
import { useLocation } from "react-router-dom";
import AVImageSlider from "../../../components/common/AVImageSlider";
import settings from "../../../Platform/settings.json";
import VoiceMessage from "../../../components/common/VoiceMessage";
import { useWindowDimension } from "../../../Utility/WindowDimensions";
import AVConfirmationModal from "../../../components/common/AVConfirmationModal";

/* ---------------------------------- Types ---------------------------------- */

type ExtendedEntity = AV.IAVEntity & {
  teams?: AV.ITypeLink[];
  childOrgs?: AV.ILink[];
  subType?: string;
  season?: string;
  activity?: string;
  CopyFromSeason?: AV.ILink[];
  roles?: AV.IRole[];
  wards?: AV.ILink[];
  staff?: AV.IStaff[];
  guardians?: AV.ILink[];
  gradClasses?: AV.ILink[];
  preferences?: AV.IPreferences;
  eventType?: string;
  reoccurance?: AV.IReoccurance;
  participants?: AV.IParticipantLink[];
  sequence?: number;
  resources?: AV.IEventResource[];
  seriesEvents?: AV.ISeriesEvent[];
};

interface Props {
  page: string;
  props: any;
  isAdminView: boolean;
  setIsAdminView: Dispatch<SetStateAction<boolean>>;
  entity: ExtendedEntity;
  setEntity: Dispatch<SetStateAction<AV.IAVEntity | undefined>>;
  leagueGameEntity: ExtendedEntity | undefined;
  setLeagueGameEntity: Dispatch<SetStateAction<AV.IAVEntity | undefined>>;
  editAccess?: boolean;
  isEntireSeriesAvailable?: boolean;
}

/* ---------------------------------- Component ---------------------------------- */

export const AVChatMessage: FC<Props> = ({
  page,
  props,
  entity,
  setEntity,
  editAccess,
  isAdminView,
  setIsAdminView,
  leagueGameEntity,
  setLeagueGameEntity,
  isEntireSeriesAvailable,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dimensions = useWindowDimension();
  const isMobile = dimensions?.width < 600;

  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user?.[0],
  );

  const userconvo = useSelector(
    (state: RootStateOrAny) => state.convo.convo[0],
  );

  const entityDataList = useSelector(
    (state: RootStateOrAny) => state?.user?.entitydatalist ?? [],
  );

  const isOnline = useSelector((state: RootStateOrAny) => state.user.isOnline);

  //const [convoEntity, setConvoEntity] = useState<AV.IAVEntity>();
  const [itemHeights, setItemHeights] = useState([]);
  const [convoLink, setConvoLink] = useState<AV.ILink | undefined>();
  const [isNewChat, setIsNewChat] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [isOpenConvo, setIsOpenConvo] = useState(false);
  const [showConvoListModal, setShowConvoListModal] = useState(false);
  const [isConvoData, setIsConvoData] = useState(false);
  const [allImages, setShowAllImage] = useState([]);
  const [singleImage, setSingleImage] = useState();
  const [isHeader, setHeader] = useState(false);
  const [setConvoImage] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [previewitem, setpreviewitem] = useState();
  const [isGroupChat, setIsGroupChat] = useState(false);
  const currentConvoIdRef = useRef<string | null>(null);

  const {
    textSearchRef,
    mdlCreateConvoVisible,
    setMdlCreateConvoVisible,
    toFK,
    searchInput,
    filteredResults,
    showSearch,
    showFilePicker,
    handleCreateModel,
    searchItems,
    handleSentToProfile,
    handleSendMessage,
    setConvoLoading,
    isLoading,
    handleSubject,
    subject,
    handleMessage,
    handleRemoveItem,
    getImageGalleryFromFilePickerCreateConvo,
    mdlConvoVisible,
    convoSubject,
    setMdlConvoVisible,
    convoPost,
    convo,
    showConvoFilePicker,
    handleGetConvo,
    handleSendConvoMessage,
    replyValue,
    setreplyValue,
    handleChatMessage,
    media,
    value,
    profile,
    Setprofile,
    setValue,
    Loading,
    images,
    setImages,
    isDelete,
    setIsdelete,
    setDeletedImages,
    setUpdateConvoImage,
    setUpdateConvoVideo,
    videoUrls,
    setvideos,
    handleImages,
    handleVoice,
    handleFilePicker,
    onRefresh,
    setSubject,
    settoFK,
    handlePublish,
    setIsHide,
    isHide,
    isImageProcessing,
    setMedia,
    refConvoList,
    setShowConvoFilePicker,
    HandleEditSet,
    handleUpdatePost,
    itemEdit,
    setItemEdit,
    editingImage,
    setEditingImage,
    setConvoPost,
    scrollToMessageWithDelay,
    fetchloading,
    setSearchInput,
    setShowSearch,
    imageInputRef,
    setConvoSubject,
    setConvos,
    typingUserName,
    setIsOpenBox,
    setIsOpenCemera,
    handleOpenPicker,
    setExternalLink,
    HandleAddOneDrive,
    setShowExternalLinkInput,
    showExternalLinkInput,
    HandleAddDropBoxLink,
    isOpenBox,
    isOpenCemera,
    HandleAddExternalUrl,
    handleExternalLink,
    externalLink,
    camera,
    isSetText,
    TriggerOpenConvo,
    setIsTriggerOpenConvo,
    isYoutube,
    setIsYouTube,
    setChatMessage,
    shrink,
    setShrink,
    translateItem,
    handleTranslateText,
    handleShowOriginalText,
    setIsOneDriveData,
    showInsufficientCredits,
    setShowInsufficientCredits,
    scrollRef,
    prevScrollHeightRef,
    prevScrollTopRef,
    loadingOldMessagesRef,
    messagesEndRef,
    setupSignalRConnection,
    handleSendSingleChat,
    cameraMode,
    setCameraMode,
    webcamRef,
    recording,
    setRecording,
    duration,
    setDuration,
    formatDuration,
    toggleMode,
    isCancelledRef,
    handleCameraPhotoCapture,
    handleStartRecording,
    handleStopRecording,
    onClose,
    addLinkLoad,
    setAddLinkLoad,
    editorRef,
    useRichText,
    setUseRichText,
    rteValue,
    setRteValue,
    toolbarOptions,
    isExpanded,
    setIsExpanded,
    setPostPopupExpanded,
    bgColor,
    setBgColor,
    bgImage,
    setBgImage,
    bgImgWidth,
    setBgImgWidth,
    bgImgHeight,
    setBgImgHeight,
    clickedUrl,
    setClickedUrl,
    showConfirmLinkPopup,
    setShowConfirmLinkPopup,
  } = useConvoChat();

  const handleuserRedirect = async (profile) => {
    setShowConvoListModal(false);
    setMdlConvoVisible(false);
    setMdlCreateConvoVisible(false);
    setConvoLoading(false);
    setIsOpenConvo(false);
    navigate(`/profile/${profile?.id}/${profile?.region}`, {
      state: { user: profile },
    });
  };

  const onEmojiClick = (event, emojiObject) => {
    const newVal = value + emojiObject.emoji;
    setValue(newVal);
    setChatMessage(newVal);
    setShrink(newVal?.trim()?.length > 0 ? true : false);
  };

  const getItemLayout = (data, index) => ({
    length: itemHeights[index] || 0,
    offset: itemHeights
      .slice(0, index)
      .reduce((acc, height) => acc + height, 0),
    index,
  });

  const list_to_tree = (list: any) => {
    var map: any = {},
      node: any,
      roots: any = [],
      i;

    for (i = 0; i < list?.length; i += 1) {
      map[list[i]?.id] = i; // initialize the map
      if (list[i]?.children?.length === 0 || !list[i]?.children)
        list[i]["children"] = []; // initialize the children
      if (list[i]?.galleryPost?.length === 0 || !list[i]?.galleryPost)
        list[i]["galleryPost"] = [];
      list[i]["ReplyPost"] = [];
    }

    for (i = 0; i < list?.length; i += 1) {
      node = list[i];
      if (node.parentPost !== undefined) {
        if (
          list[map[node.parentPost]]?.gallery?.items?.filter(
            (x: any) => x === node.id,
          )?.length > 0 &&
          node.gallery == undefined
        ) {
          let excitingpost = list[map[node.parentPost]]?.galleryPost?.filter(
            (x: any) => x?.id === node?.id,
          );
          if (excitingpost?.length === 0 || excitingpost === undefined)
            list[map[node.parentPost]]?.galleryPost.push(node);
        } else {
          let PPost = list.filter((x: any) => x?.id === node?.parentPost);
          node.ReplyPost.push(PPost[0]);
          roots.push(node);
        }
      } else {
        roots.push(node);
      }
    }
    return roots;
  };

  const getConvo = async (item?: any) => {
    let currentConvo = item;
    const previousConvoId = currentConvoIdRef.current;
    let convoFK = convoLink;

    if (
      !convoFK?.id &&
      currentConvo?.id &&
      ["GameGroupConvo", "LeagueGameGroupConvo"].includes(currentConvo.type)
    ) {
      convoFK = currentConvo;
      currentConvo = undefined;
    }

    if (!convoFK?.id) return;

    const convoFeed: AV.IFK = {
      id: convoFK.id,
      pk: convoFK.pk,
      region: convoFK.region,
      type:
        convoFK?.type === "GameGroupConvo" ||
        convoFK?.type === "LeagueGameGroupConvo"
          ? convoFK?.type
          : "GroupConvo",
    };

    const param: AV.IFeedParam = {
      feed: convoFeed,
      checkArchive: false,
      forward: true,
      startDate: new Date(0),
    };

    const feedParams: AV.IFeedParam[] = [param];

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    const feedsResponse: any = (await AV.Feed.getAllFeeds(
      feedParams,
    )) as AV.IConversation[];

    // If feed returns no results, exit early
    if (!feedsResponse?.[0]) return;

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Sort privateIds by date descending (latest first)
    let filteredPrivateIds = _.orderBy(
      feedsResponse[0].privateIds,
      ["date"],
      ["desc"],
    );

    const group: Record<string, AV.IPostListParam> = {};

    // Group privateIds under the same convo ID for batching
    filteredPrivateIds.forEach(({ id }) => {
      const convoId = convoFK?.id;
      if (!convoId) return;

      if (!group[convoId]) {
        group[convoId] = { feed: convoFeed, ids: [] };
      }

      group[convoId].ids!.push(id);
    });

    // Flatten the batched group to individual { feed, id } objects
    const batched: AV.IPostListParam[] = Object.values(group);
    const flattened = batched.flatMap(({ feed, ids }) =>
      (ids ?? []).map((id) => ({ feed, id })),
    );

    // Limit to first 20 posts per batch
    const first20 = flattened.slice(0, 20);

    // Group again for Feed.getAllPosts format
    const groupByFeed = (items: { feed: AV.IFK; id: string }[]) => {
      const map = new Map<string, { feed: AV.IFK; ids: string[] }>();
      items.forEach(({ feed, id }) => {
        if (!feed?.id) return;

        if (!map.has(feed.id)) {
          map.set(feed.id, { feed, ids: [] });
        }
        map.get(feed.id)!.ids.push(id);
      });
      return Array.from(map.values());
    };

    const firstBatch = groupByFeed(first20);

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Fetch the posts by ID from Feed
    let fetchPosts =
      firstBatch.length > 0 ? await AV.Feed.getAllPosts(firstBatch) : [];

    // Check if user switched chats
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Fetch replies if posts are threaded
    if (Array.isArray(fetchPosts)) {
      fetchPosts = await fetchReplyPosts(fetchPosts, firstBatch);
    }

    // Merge fetched posts into current user conversation
    let convoChat = userconvo?.find((x) => x?.id === convoFK?.id);

    // Merge posts and remove duplicates
    let allFeeds = [...(convoChat?.posts ?? []), ...fetchPosts];
    allFeeds = _.uniqBy(allFeeds, "id");

    // Convert to tree structure for threaded conversations
    allFeeds = list_to_tree(allFeeds);

    // Sort posts by createDate descending (latest first)
    allFeeds = allFeeds.sort(
      (a, b) =>
        new Date(b.createDate).getTime() - new Date(a.createDate).getTime(),
    );

    // Check again before updating state
    if (previousConvoId !== currentConvoIdRef.current) {
      return;
    }

    // Update the post list in local and redux state
    if (convoChat?.id?.length > 0) convoChat.posts = allFeeds;
    if (currentConvo?.id?.length > 0) {
      currentConvo.posts = allFeeds;
      //convoChat.privateIds = currentConvo.privateIds;
    } else if (currentConvo !== undefined) {
      currentConvo.posts = allFeeds;
    }

    const index = userconvo?.findIndex((x) => x.id === convoFK?.id);
    if (index !== -1) {
      userconvo[index] =
        convoChat?.id?.length > 0 ? convoChat : feedsResponse[0];
    } else if (feedsResponse.length > 0) {
      let usercon: any = [];
      if (userconvo?.length > 0) usercon = userconvo;

      feedsResponse[0].posts = allFeeds;
      setConvos(feedsResponse[0]);
      usercon.unshift(feedsResponse[0]);
      dispatch(setConvo(usercon));
    }

    handleGetConvo(
      currentConvo?.id?.length > 0 ? currentConvo : feedsResponse[0],
    ); // Refresh UI
  };

  async function fetchReplyPosts(
    postList: AV.IPost[],
    postsToFetch: AV.IPostListParam[],
  ): Promise<AV.IPost[]> {
    const replyPostIds = postList
      .filter((x) => Array.isArray(x.posts) && x.posts.length > 0) // Only posts with nested replies
      .map((x) => ({ id: x.id, pk: x.pk, posts: x.posts })); // Collect their post IDs and pk

    if (replyPostIds.length === 0) return postList; // No replies to fetch

    const replyPostListParams: AV.IPostListParam[] = [];
    const uniquePks = [
      ...new Set(
        replyPostIds.map((r) => r.pk).filter((pk): pk is string => !!pk),
      ),
    ]; // Unique pk list

    // Match original fetch request with replies using pk
    uniquePks.forEach((pk) => {
      const matchedFeed = postsToFetch.filter((x) => x.feed.pk === pk);
      if (matchedFeed.length > 0) {
        replyPostListParams.push({
          feed: matchedFeed[0].feed,
          ids: replyPostIds.find((x) => x.pk === pk)?.posts || [],
        });
      }
    });

    const replyPostList = await AV.Feed.getAllPosts(replyPostListParams); // Fetch reply posts
    return _.uniqBy([...postList, ...replyPostList], "id"); // Merge with original and dedupe
  }

  const GetEntity = async () => {
    if (!convoLink) return;

    let EntityItem = entityDataList.filter(
      (x: AV.IAVEntity) => x?.id === convoLink?.id,
    );
    if (EntityItem?.length === 0) {
      let entityData: AV.IAVEntity = await AV.AVEntity.get(convoLink);
      //setConvoEntity(entityData);
      entityDataList.push(entityData);
      dispatch(setEntitydata(entityDataList));

      const isAdminOrStaff = //entityData?.status === "Deleted"
        //  ? false
        //  :
        (entityData as any)?.staff?.some(
          (x) => x?.id === currentUser?.id, //&& x?.role?.isOwner,
        );
      //setIsAdminView(isAdminOrStaff);
    } else {
      //setConvoEntity(EntityItem[0]);
      let entityData: AV.IAVEntity = await AV.AVEntity.get(convoLink);
      const index = entityDataList?.findIndex(
        (x: AV.IAVEntity) => x?.id === entityData?.id,
      );
      if (index !== -1) {
        entityDataList[index] = entityData;
        dispatch(setEntitydata(entityDataList));
        //setConvoEntity(entityData);
      }

      const isAdminOrStaff = //entityData?.status === "Deleted"
        //  ? false
        //  :
        (entityData as any)?.staff?.some(
          (x) => x?.id === currentUser?.id, //&& x?.role?.isOwner,
        );
      //setIsAdminView(isAdminOrStaff);
    }
  };

  useEffect(() => {
    let img: AV.IMedia[] = [];
    let videoUrl: AV.IMedia[] = [];
    let docsUrl: AV.IMedia[] = [];
    setDeletedImages([]);
    if (itemEdit?.media) img.push(itemEdit.media);

    itemEdit?.galleryPost?.map((item1) => {
      if (item1?.media) img.push(item1.media);
    });
    if (img?.length > 0) {
      setShowConvoFilePicker(true);
      setEditingImage(true);
      setImages(img);
    }

    if (videoUrl?.length > 0) {
      setShowConvoFilePicker(true);
      setEditingImage(true);
      setvideos(videoUrl);
    }
  }, [itemEdit]);

  useEffect(() => {
    let isMounted = true;

    setConvos([]);
    setConvoPost([]);
    setValue("");
    //setConvoEntity("");
    const convo =
      entity?.type === "LeagueGameBase"
        ? entity?.convos?.find((x) => x?.type === "LeagueGameGroupConvo")
        : entity?.convos?.find((x) => x?.type === "GameGroupConvo");

    setConvoLink(convo);

    if (isMounted && Boolean(convo?.id?.trim())) {
      const postData = userconvo?.filter((x) => x?.id === convo?.id);

      if (postData?.length > 0) {
        currentConvoIdRef.current = postData[0].id; // Track the current chat ID
        handleGetConvo(postData[0]);
        getConvo(postData[0]);
        //GetEntity();
      } else {
        currentConvoIdRef.current = convo?.id ?? null;
        getConvo(convo);
        //GetEntity();
      }
    }

    return () => {
      isMounted = false;
    };
  }, [entity, leagueGameEntity]);

  const RenderImages = ({
    images,
    itemEdit,
    setImages,
    setDeletedImages,
    setUpdateConvoImage,
    setUpdateConvoVideo,
    media,
    setMedia,
    isImageProcessing,
    editingImage,
    setEditingImage,
    setIsdelete,
    useRichText = false,
    isExpanded = false,
  }) => {
    const [isAPICall, setIsAPICall] = useState(false);
    const [isConfirm, setIsConfirm] = useState(false);
    const [removedItems, setRemovedItems] = useState<any | null>(null);

    useEffect(() => {}, [editingImage]);

    let imgmedia: AV.IMedia[] = [];
    let vidmedia: AV.IMedia[] = [];

    images?.forEach((img) => {
      if (editingImage) {
        if (images?.length > 0) {
          if (img) {
            imgmedia?.push(img);
          } else {
            vidmedia.push(img);
          }
        }
      } else {
        if (images?.length > 0) {
          if (img) {
            imgmedia?.push(img);
          }
        } else vidmedia.push(img);
      }
    });

    const handleRemoveItem = (item) => {
      setIsdelete?.(true);
      setIsConfirm(true);
      setRemovedItems(item);
    };

    const deleteImage = (item?: any) => {
      const deleteItem = removedItems ?? item;
      if (!deleteItem) return;

      setDeletedImages((prev) => [...prev, deleteItem?.id]);

      let filterImages = images?.filter((x, i) => x?.id !== deleteItem?.id);
      setImages(filterImages);

      setUpdateConvoImage(
        filterImages?.filter((x, i) => !x?.type?.startsWith("video")),
      );

      const filterVideos = filterImages?.filter(
        (x, i) => x?.type?.startsWith("video") && x?.id !== deleteItem?.id,
      );
      if (filterVideos) {
        setUpdateConvoVideo(filterVideos);
      }

      let filterMedia = media?.filter((x, i) => x?.id !== deleteItem?.id);
      setMedia(filterMedia);

      if (
        (itemEdit?.id?.length === undefined || itemEdit?.id?.length === 0) &&
        filterImages?.length === 0
      ) {
        //setValue("");
        setItemEdit("");
        //setShrink(false);
        setEditingImage(false);
        setShowConvoFilePicker(false);
      }

      setIsAPICall(false);
      setIsdelete?.(false);
      setIsConfirm(false);
    };

    return (
      <>
        <VStack px={1}>
          <HStack space={1} alignItems={"center"}></HStack>
          <HStack overflow="scroll" maxWidth={useRichText ? "100%" : "600px"}>
            {images.map((item, i) => {
              return (
                <Box
                  key={item?.id || i}
                  m={1}
                  width={item?.type?.startsWith("audio") ? "205px" : "120px"}
                  height={"120px"}
                >
                  <Box
                    position={"absolute"}
                    top={1}
                    right={1}
                    bgColor={"white"}
                    rounded={"full"}
                    zIndex={100}
                  >
                    {!isImageProcessing && (
                      <AVCancel
                        size={"10px"}
                        callback={() => {
                          handleRemoveItem(item);
                        }}
                        color={"#000000"}
                      />
                    )}
                  </Box>
                  {item?.type?.startsWith("image") ||
                  (!item?.id &&
                    typeof item === "string" &&
                    item.startsWith("data:image")) ||
                  item?.type == "Onedrive" ||
                  item?.type == "dropbox" ? (
                    <img
                      src={
                        item?.type === "dropbox"
                          ? item?.orgFile
                          : item?.linkURL
                            ? item?.linkURL
                            : !item?.id &&
                                typeof item === "string" &&
                                item.startsWith("data:image")
                              ? item
                              : Media.getURL(item)
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover" }}
                    />
                  ) : item?.type === "iframe" ? (
                    <iframe
                      src={item?.linkURL}
                      width="100%"
                      height="100%"
                    ></iframe>
                  ) : item?.type == "linkPreview" ? (
                    <SimpleLinkPreview url={item} />
                  ) : item?.type?.startsWith("application") ? (
                    <img
                      src={
                        (item?.type === "application/pdf" && settings.pdf) ||
                        ((item?.type === "application/msword" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                          settings.word) ||
                        ((item?.type === "application/vnd.ms-powerpoint" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                          settings.powerpoint) ||
                        ((item?.type === "application/vnd.ms-excel" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
                          settings.excel) ||
                        settings.file
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type === "text/plain" ? (
                    <img
                      src={settings.file}
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type?.startsWith("audio") ? (
                    <VoiceMessage
                      audioUrl={Media.getURL(item)}
                      onRecordingComplete={() => {}}
                    />
                  ) : (
                    <div className="processing-container">
                      <img
                        src={Media.getVideoPicURL(item)}
                        alt=""
                        className="Image"
                        width="100%"
                        height="100%"
                        style={{
                          objectFit: "contain",
                          backgroundColor: "#eeeeee",
                        }}
                      />
                      <Box
                        position="absolute"
                        top={"50%"}
                        left={"50%"}
                        style={{
                          transform: [{ translateX: -30 }, { translateY: -30 }],
                        }}
                      >
                        <VideoIcon size={"60px"} color={"white"} />
                      </Box>
                    </div>
                  )}
                </Box>
              );
            })}
          </HStack>
        </VStack>

        {isConfirm && (
          <AVConfirmationModal
            showconfirmationPopup={isConfirm}
            setshowconfirmationPopup={setIsConfirm}
            setIsdelete={setIsdelete}
            Confirmationtext={
              Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem
            }
            type={"ChatImageRemove"}
            item={undefined}
            function={deleteImage}
            isLoader={isAPICall}
          />
        )}
      </>
    );
  };

  const ReplyLoadMedia = ({ item, isDetail = false }) => {
    const [imageUrls, setImagesUrl] = useState<AV.IMedia[]>([]);
    const [videoUrls, setVideoUrl] = useState<AV.IMedia[]>([]);
    const [media, setMedia] = useState<any>([]);

    useEffect(() => {
      setMedia([]);
      if (
        item?.media?.storeId &&
        (item?.galleryPost?.length == 0 ||
          item?.galleryPost?.length == undefined)
      ) {
        imageUrls.push(item?.media);
        setMedia(imageUrls);
      } else if (item?.galleryPost?.length > 0) {
        // Loop through gallery posts and add media
        for (let i = 0; i < item?.galleryPost?.length; i++) {
          imageUrls.push(item?.galleryPost[i].media);
        }
        setMedia(imageUrls);
      }
    }, []);

    return (
      <>
        <VStack px={1}>
          <HStack overflow="scroll" maxWidth={"400px"}>
            {media.map((item, i) => {
              return (
                <Box
                  m={1}
                  width={item?.type?.startsWith("audio") ? "310px" : "100px"}
                  height={item?.type?.startsWith("audio") ? "42px" : "72px"}
                >
                  <Box
                    position={"absolute"}
                    top={1}
                    right={1}
                    bgColor={"white"}
                    rounded={"full"}
                    zIndex={100}
                  ></Box>
                  {item?.type?.startsWith("image") ||
                  (!item?.id &&
                    typeof item === "string" &&
                    item.startsWith("data:image")) ||
                  item?.type == "Onedrive" ||
                  item?.type == "dropbox" ? (
                    <img
                      src={
                        item?.type === "dropbox"
                          ? item?.orgFile
                          : item?.linkURL
                            ? item?.linkURL
                            : !item?.id &&
                                typeof item === "string" &&
                                item.startsWith("data:image")
                              ? item
                              : Media.getURL(item)
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover" }}
                    />
                  ) : item?.type === "iframe" ? (
                    <iframe
                      src={item?.linkURL}
                      width="100%"
                      height="100%"
                    ></iframe>
                  ) : item?.type == "linkPreview" ? (
                    <SimpleLinkPreview url={item} />
                  ) : item?.type?.startsWith("application") ? (
                    <img
                      src={
                        (item?.type === "application/pdf" && settings.pdf) ||
                        ((item?.type === "application/msword" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                          settings.word) ||
                        ((item?.type === "application/vnd.ms-powerpoint" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                          settings.powerpoint) ||
                        ((item?.type === "application/vnd.ms-excel" ||
                          item?.type ===
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
                          settings.excel) ||
                        settings.file
                      }
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type === "text/plain" ? (
                    <img
                      src={settings.file}
                      alt=""
                      className="Image"
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        backgroundColor: "#eeeeee",
                      }}
                    />
                  ) : item?.type?.startsWith("audio") ? (
                    <HStack
                      space={2}
                      width={"100%"}
                      marginLeft={20}
                      justifyContent={"center"}
                      alignItems="center"
                      bg="rgba(0,0,0,0.05)"
                      p={2}
                      borderRadius="md"
                    >
                      <MicIcon size="24px" color="AVColor.primary" />

                      <Text color="#32AE78" fontSize="sm">
                        {Loc.currentLang.menu.voiceMessage}
                      </Text>
                      {/* <Text color="gray.500" fontSize="xs">
                      {formatDuration(media?.duration || 0)}
                    </Text> */}
                    </HStack>
                  ) : (
                    <div className="processing-container">
                      <img
                        src={Media.getVideoPicURL(item)}
                        alt=""
                        className="Image"
                        width="100%"
                        height="100%"
                        style={{
                          objectFit: "contain",
                          backgroundColor: "#eeeeee",
                        }}
                      />
                      <Box
                        position="absolute"
                        top={"50%"}
                        left={"50%"}
                        style={{
                          transform: [{ translateX: -30 }, { translateY: -30 }],
                        }}
                      >
                        <VideoIcon size={"60px"} color={"white"} />
                      </Box>
                    </div>
                  )}
                </Box>
              );
            })}
          </HStack>
        </VStack>
      </>
    );
  };

  const SimpleLinkPreview = ({ url }) => {
    return (
      <div className="link-preview-wrapper">
        <div className="link-preview-image">
          <img src={url?.orgFile} alt="images" />
        </div>
        <div className="link-preview-content">
          <Pressable onPress={() => Linking.openURL(url?.linkURL)}>
            <p className="link-url">{url?.linkURL}</p>
          </Pressable>
        </div>
      </div>
    );
  };

  return (
    <>
      <Box flex={1}>
        {(convoLink?.id && convo?.posts?.length > 0) ||
        (leagueGameEntity && leagueGameEntity?.status !== "Ended") ||
        entity?.type === "LeagueGameBase" ? (
          <Messages
            camera={camera}
            isSetText={isSetText}
            isHeader={false}
            isNewChat={isNewChat}
            setIsNewChat={setIsNewChat}
            isGroupChat={isGroupChat}
            setIsGroupChat={setIsGroupChat}
            isConvoData={isConvoData}
            setIsConvoData={setIsConvoData}
            setShowEmoji={setShowEmoji}
            RenderImages={RenderImages}
            showEmoji={showEmoji}
            imageInputRef={imageInputRef}
            onEmojiClick={onEmojiClick}
            handleuserRedirect={handleuserRedirect}
            getItemLayout={getItemLayout}
            ReplyLoadMedia={ReplyLoadMedia}
            setHeader={setHeader}
            setShowAllImage={setShowAllImage}
            setSingleImage={setSingleImage}
            setShowPreview={setShowPreview}
            setConvoImage={setConvoImage}
            setItemHeights={setItemHeights}
            itemHeights={itemHeights}
            props={props}
            mdlConvoVisible={mdlConvoVisible}
            textSearchRef={textSearchRef}
            mdlCreateConvoVisible={mdlCreateConvoVisible}
            typingUserName={typingUserName}
            setConvoSubject={setConvoSubject}
            setConvos={setConvos}
            isOpenConvo={true}
            setIsOpenConvo={setIsOpenConvo}
            setShowConvoListModal={setShowConvoListModal}
            setMdlCreateConvoVisible={setMdlCreateConvoVisible}
            toFK={toFK}
            searchInput={searchInput}
            filteredResults={filteredResults}
            showSearch={showSearch}
            handleExternalLink={handleExternalLink}
            externalLink={externalLink}
            showFilePicker={showFilePicker}
            handleCreateModel={handleCreateModel}
            searchItems={searchItems}
            handleSentToProfile={handleSentToProfile}
            handleSendMessage={handleSendMessage}
            setConvoLoading={setConvoLoading}
            isLoading={isLoading}
            handleSubject={handleSubject}
            subject={subject}
            isDelete={isDelete}
            setIsdelete={setIsdelete}
            setUpdateConvoImage={setUpdateConvoImage}
            setUpdateConvoVideo={setUpdateConvoVideo}
            handleMessage={handleMessage}
            handleRemoveItem={handleRemoveItem}
            getImageGalleryFromFilePickerCreateConvo={
              getImageGalleryFromFilePickerCreateConvo
            }
            convoSubject={convoSubject}
            setMdlConvoVisible={setMdlConvoVisible}
            convoPost={convoPost}
            convo={convo}
            showConvoFilePicker={showConvoFilePicker}
            handleGetConvo={handleGetConvo}
            handleSendConvoMessage={handleSendConvoMessage}
            replyValue={replyValue}
            setreplyValue={setreplyValue}
            handleChatMessage={handleChatMessage}
            media={media}
            value={value}
            profile={profile}
            Setprofile={Setprofile}
            setValue={setValue}
            Loading={Loading}
            images={images}
            setImages={setImages}
            setDeletedImages={setDeletedImages}
            setItemEdit={setItemEdit}
            videoUrls={videoUrls}
            isOpenBox={isOpenBox}
            setIsOpenBox={setIsOpenBox}
            setExternalLink={setExternalLink}
            HandleAddOneDrive={HandleAddOneDrive}
            setShowExternalLinkInput={setShowExternalLinkInput}
            showExternalLinkInput={showExternalLinkInput}
            HandleAddDropBoxLink={HandleAddDropBoxLink}
            setIsOpenCemera={setIsOpenCemera}
            handleOpenPicker={handleOpenPicker}
            isOpenCemera={isOpenCemera}
            HandleAddExternalUrl={HandleAddExternalUrl}
            setvideos={setvideos}
            handleImages={handleImages}
            handleVoice={handleVoice}
            handleFilePicker={handleFilePicker}
            onRefresh={onRefresh}
            setSubject={setSubject}
            settoFK={settoFK}
            handlePublish={handlePublish}
            setIsHide={setIsHide}
            isHide={isHide}
            isImageProcessing={isImageProcessing}
            setMedia={setMedia}
            refConvoList={refConvoList}
            setShowConvoFilePicker={setShowConvoFilePicker}
            HandleEditSet={HandleEditSet}
            handleUpdatePost={handleUpdatePost}
            itemEdit={itemEdit}
            isYoutube={isYoutube}
            setIsYouTube={setIsYouTube}
            editingImage={editingImage}
            setSearchInput={setSearchInput}
            setShowSearch={setShowSearch}
            setEditingImage={setEditingImage}
            setConvoPost={setConvoPost}
            fetchloading={fetchloading}
            isHuddleChatTab={true}
            shrink={shrink}
            setShrink={setShrink}
            translateItem={translateItem}
            handleTranslateText={handleTranslateText}
            handleShowOriginalText={handleShowOriginalText}
            setIsOneDriveData={setIsOneDriveData}
            showInsufficientCredits={showInsufficientCredits}
            setShowInsufficientCredits={setShowInsufficientCredits}
            scrollRef={scrollRef}
            prevScrollHeightRef={prevScrollHeightRef}
            prevScrollTopRef={prevScrollTopRef}
            loadingOldMessagesRef={loadingOldMessagesRef}
            messagesEndRef={messagesEndRef}
            setupSignalRConnection={setupSignalRConnection}
            cameraMode={cameraMode}
            setCameraMode={setCameraMode}
            webcamRef={webcamRef}
            recording={recording}
            setRecording={setRecording}
            duration={duration}
            setDuration={setDuration}
            formatDuration={formatDuration}
            toggleMode={toggleMode}
            isCancelledRef={isCancelledRef}
            handleCameraPhotoCapture={handleCameraPhotoCapture}
            handleStartRecording={handleStartRecording}
            handleStopRecording={handleStopRecording}
            onClose={onClose}
            addLinkLoad={addLinkLoad}
            setAddLinkLoad={setAddLinkLoad}
            editorRef={editorRef}
            useRichText={useRichText}
            setUseRichText={setUseRichText}
            rteValue={rteValue}
            setRteValue={setRteValue}
            toolbarOptions={toolbarOptions}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            setPostPopupExpanded={setPostPopupExpanded}
            bgColor={bgColor}
            setBgColor={setBgColor}
            bgImage={bgImage}
            setBgImage={setBgImage}
            bgImgWidth={bgImgWidth}
            setBgImgWidth={setBgImgWidth}
            bgImgHeight={bgImgHeight}
            setBgImgHeight={setBgImgHeight}
            clickedUrl={clickedUrl}
            setClickedUrl={setClickedUrl}
            showConfirmLinkPopup={showConfirmLinkPopup}
            setShowConfirmLinkPopup={setShowConfirmLinkPopup}
            entityData={entity /*convoEntity*/}
            isGameEnded={
              leagueGameEntity?.status === "Ended" ||
              (entity?.type === "LeagueGameBase" && entity?.status === "Ended")
            }
          />
        ) : (
          page === "header" &&
          (leagueGameEntity?.status === "Ended" ||
            (entity?.type === "LeagueGameBase" &&
              entity?.status === "Ended")) && (
            <Box pt={1} h={"120px"} maxH={"120px"}>
              <Box py={6} alignItems="center">
                <Text fontSize="13px" color="coolGray.400">
                  {Loc.currentLang.gameEvent.noChatHistoryFound}
                </Text>
              </Box>
            </Box>
          )
        )}
      </Box>
    </>
  );
};

export default AVChatMessage;
